import React from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import Column from '../components/Column';
import { Button } from 'react-bootstrap';
import '../assets/css/styles.css'
import '../assets/css/challenge.css';
import Footer from '../components/Footer';


class Challenge extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    onDragEnd = result => {
        const { destination, source, draggableId } = result;
        // console.log(result);

        if (!destination) {
            return;
        }

        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return;
        }
        // const column = this.state.columns[source.droppableId];
        const newTaskIds = this.props.currentState[0].steps;
        let newT = newTaskIds.filter(function (newT) {
            return newT.sid === draggableId
        })
        newTaskIds.splice(source.index, 1);
        newTaskIds.splice(destination.index, 0, newT[0]);

        const newState = {
            ...this.props.currentState,
            [this.props.currentState.steps]: newTaskIds
        };

        console.log(newState)


        this.props.setResponse(newState);
    };


    render() {
        return (
            <>
                <DragDropContext onDragEnd={this.onDragEnd}>
                    {this.props.currentState.map(columnId => {
                        const column = columnId;
                        // console.log(columnId);
                        const tasks = column.steps

                        return <Column key={column} column={column} tasks={tasks} order={this.props.order} />
                    })}
                </DragDropContext>
                <div className="d-flex main-button-row">
                    <Button
                        variant="primary"
                        onClick={() => this.props.updateBackend()}
                    >
                        How did I do?
                    </Button>
                </div>
                <Footer />

            </>
        )
    }
}

export default Challenge;